<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Floral Variety', apiMethod: 'FloralVarieties', form: () => import('../forms/FloralVarietyForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Floral Variety Nickname', apiMethod: 'FloralVarietyNicknames', parentForeignKey: 'floralVarietyId', form: () => import('../forms/FloralVarietyNicknameForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Harvesting Floral Variety', apiMethod: 'HarvestingFloralVarieties', parentForeignKey: 'floralVarietyId', form: () => import('../forms/HarvestingFloralVarietyForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Site Floral Variety', apiMethod: 'SiteFloralVarieties', parentForeignKey: 'floralVarietyId', form: () => import('../forms/SiteFloralVarietyForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Nicknames', value: 'floralVarietyId', isCard: true, table: () => import('../tables/FloralVarietyNicknamesTable') },
                    { text: 'Harvestings', value: 'floralVarietyId', isCard: true, table: () => import('../tables/HarvestingFloralVarietiesTable') },
                    { text: 'Packer Containers', value: 'floralVarietyId', table: () => import('../tables/PackerContainersTable') },
                    { text: 'Samples', value: 'floralVarietyId', table: () => import('../tables/SamplesTable') },
                    { text: 'Sites', value: 'floralVarietyId', isCard: true, table: () => import('../tables/SiteFloralVarietiesTable') },
                ],
                mainForm: () => import('../forms/FloralVarietyForm'),
                claimName: 'FloralVarieties',
                apiMethod: 'FloralVarieties',
            }
        }
    };
</script>
